export enum EReportConfigurationMessages {
    CLEAR_FORM_FIELDS_CONFIRM_TEXT = 'Вы уверены, что хотите очистить эту форму? ',
    CLOSE_FORM_CONFIRM_TEXT = 'У вас есть несохраненные изменения, '
        + 'при закрытии формы изменения не будут сохранены. Закрыть форму?',
}
